import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from '../lib/axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../components/ui/alert-dialog';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Badge } from '../components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Plus, Edit, Trash2, Search, Phone, Mail, MapPin, UserPlus, X, Upload, Users, Tag, UserCircle2, Eye, Ship, FolderKanban, DollarSign, Calendar, Building2, Anchor, History } from 'lucide-react';
import { toast } from 'sonner';
import { TitleWithHelp } from '../components/ui/help-tooltip';
import { ViewToggle } from '../components/ui/view-toggle';
import { HistoricoClienteModal } from '../components/HistoricoCliente';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('nautilus_token')}` }
});

const SEGMENTOS = [
  { value: '', label: 'Não definido' },
  { value: 'governo', label: 'Governo / Forças Armadas' },
  { value: 'privado', label: 'Empresa Privada' },
  { value: 'ong', label: 'ONG / Associação' },
  { value: 'pessoa_fisica', label: 'Pessoa Física' },
];

const ORIGENS = [
  { value: '', label: 'Não definida' },
  { value: 'indicacao', label: 'Indicação' },
  { value: 'licitacao', label: 'Licitação' },
  { value: 'site', label: 'Site' },
  { value: 'evento', label: 'Evento / Feira' },
  { value: 'importacao', label: 'Importação CSV' },
  { value: 'outro', label: 'Outro' },
];

const ESTADOS_BR = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'];

const STATUS_PROJETO = {
  nao_iniciado: { label: 'Não Iniciado', color: 'bg-gray-100 text-gray-700' },
  em_producao: { label: 'Em Produção', color: 'bg-blue-100 text-blue-700' },
  em_atraso: { label: 'Em Atraso', color: 'bg-red-100 text-red-700' },
  concluido: { label: 'Concluído', color: 'bg-green-100 text-green-700' },
};

const emptyForm = {
  nome: '', razao_social: '', tipo_pessoa: 'juridica', cnpj: '', cpf: '', id_estrangeiro: '',
  inscricao_estadual: '', codigo: '', status: 'ativo', segmento: '', tags: [], origem: '',
  email: '', telefone: '', cep: '', estado: '', cidade: '', endereco: '', numero: '',
  bairro: '', complemento: '', contatos: [], data_fundacao: '', observacoes: '',
  frota: [],
};

const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const CrmClientes = () => {
  const [clientes, setClientes] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [editingCliente, setEditingCliente] = useState(null);
  const [deleteClienteId, setDeleteClienteId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('todos');
  const [filterSegmento, setFilterSegmento] = useState('todos');
  const [filterEstado, setFilterEstado] = useState('todos');
  const [activeTab, setActiveTab] = useState('dados');
  const [viewMode, setViewMode] = useState('list');
  const [form, setForm] = useState(emptyForm);
  const [showImportDialog, setShowImportDialog] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [tagInput, setTagInput] = useState('');
  // Visão 360
  const [show360, setShow360] = useState(false);
  const [cliente360, setCliente360] = useState(null);
  const [loading360, setLoading360] = useState(false);
  // Histórico centralizado
  const [historicoCliente, setHistoricoCliente] = useState(null);

  useEffect(() => { fetchClientes(); fetchStats(); }, []);

  const fetchClientes = async (search = '') => {
    try {
      const params = search ? `?search=${encodeURIComponent(search)}` : '';
      const res = await api.get(`/crm-clientes${params}`);
      setClientes(res.data);
    } catch { toast.error('Erro ao carregar clientes'); }
    finally { setLoading(false); }
  };

  // Debounce: buscar no backend quando o termo de busca muda
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchClientes(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]); // eslint-disable-line

  const fetchStats = async () => {
    try { const res = await api.get('/crm-clientes/stats'); setStats(res.data); } catch {}
  };

  const fetch360 = async (clienteId) => {
    setLoading360(true);
    try {
      const res = await api.get(`/crm-clientes/${clienteId}/360`);
      setCliente360(res.data);
      setShow360(true);
    } catch { toast.error('Erro ao carregar visão 360°'); }
    finally { setLoading360(false); }
  };

  const filteredClientes = useMemo(() => {
    return clientes.filter(c => {
      const s = searchTerm.toLowerCase();
      const matchSearch = !searchTerm ||
        (c.nome || '').toLowerCase().includes(s) ||
        (c.razao_social || '').toLowerCase().includes(s) ||
        (c.cnpj || '').includes(searchTerm) ||
        (c.cpf || '').includes(searchTerm) ||
        (c.email || '').toLowerCase().includes(s) ||
        (c.cidade || '').toLowerCase().includes(s) ||
        (c.contatos || []).some(ct => (ct.nome || '').toLowerCase().includes(s) || (ct.telefone || '').includes(searchTerm));
      const matchStatus = filterStatus === 'todos' || c.status === filterStatus;
      const matchSegmento = filterSegmento === 'todos' || c.segmento === filterSegmento;
      const matchEstado = filterEstado === 'todos' || c.estado === filterEstado;
      return matchSearch && matchStatus && matchSegmento && matchEstado;
    });
  }, [clientes, searchTerm, filterStatus, filterSegmento, filterEstado]);

  const handleSubmit = async () => {
    // Auto-fallback: se nome/telefone/email da empresa não foram preenchidos, usa do contato principal
    const principal = (form.contatos || []).find(c => c?.principal) || (form.contatos || [])[0];
    const nomeEmpresa = (form.nome || '').trim() || (principal?.nome || '').trim();
    const telefoneEmpresa = (form.telefone || '').trim()
      || (principal?.telefone || '').trim()
      || (principal?.whatsapp || '').trim();
    const emailEmpresa = (form.email || '').trim() || (principal?.email || '').trim();

    if (!nomeEmpresa) {
      toast.error('Nome é obrigatório (aba Dados ou marque um contato como principal com nome)');
      setActiveTab('dados');
      return;
    }

    // Documento obrigatório conforme tipo de pessoa
    if (form.tipo_pessoa === 'juridica' && !(form.cnpj || '').trim()) {
      toast.error('CNPJ é obrigatório para pessoa jurídica');
      setActiveTab('dados');
      return;
    }
    if (form.tipo_pessoa === 'fisica' && !(form.cpf || '').trim()) {
      toast.error('CPF é obrigatório para pessoa física');
      setActiveTab('dados');
      return;
    }
    if (form.tipo_pessoa === 'estrangeiro' && !(form.id_estrangeiro || '').trim()) {
      toast.error('ID Estrangeiro é obrigatório');
      setActiveTab('dados');
      return;
    }

    if (!emailEmpresa) {
      toast.error('E-mail é obrigatório (aba Dados ou em um contato)');
      setActiveTab(form.contatos.length > 0 ? 'contatos' : 'dados');
      return;
    }
    if (!telefoneEmpresa) {
      toast.error('Telefone é obrigatório (aba Dados ou em um contato)');
      setActiveTab(form.contatos.length > 0 ? 'contatos' : 'dados');
      return;
    }

    const payload = { ...form, nome: nomeEmpresa, telefone: telefoneEmpresa, email: emailEmpresa };

    setSubmitLoading(true);
    try {
      if (editingCliente) {
        await api.put(`/crm-clientes/${editingCliente.id}`, payload);
        toast.success('Cliente atualizado');
      } else {
        await api.post('/crm-clientes', payload);
        toast.success('Cliente cadastrado');
      }
      setShowDialog(false); setEditingCliente(null); setForm(emptyForm);
      fetchClientes(searchTerm); fetchStats();
    } catch (err) { toast.error(err.response?.data?.detail || 'Erro ao salvar'); }
    finally { setSubmitLoading(false); }
  };

  const handleEdit = (cliente) => {
    setEditingCliente(cliente);
    // Normaliza contatos legados: garante id e marca o primeiro como principal se nenhum for
    const contatosNormalizados = (cliente.contatos || []).map((c, i) => ({
      ...c,
      id: c.id || ((typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `ct_legacy_${i}_${Date.now()}`),
      principal: !!c.principal,
    }));
    if (contatosNormalizados.length > 0 && !contatosNormalizados.some(c => c.principal)) {
      contatosNormalizados[0].principal = true;
    }
    setForm({ ...emptyForm, ...cliente, contatos: contatosNormalizados, tags: cliente.tags || [], frota: cliente.frota || [] });
    setActiveTab('dados');
    setShowDialog(true);
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/crm-clientes/${deleteClienteId}`);
      toast.success('Cliente excluído'); setDeleteClienteId(null);
      fetchClientes(searchTerm); fetchStats();
    } catch { toast.error('Erro ao excluir'); }
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportLoading(true); setImportResult(null);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await api.post(`/crm-clientes/import-csv`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setImportResult(res.data);
      toast.success(`${res.data.importados} clientes importados`);
      fetchClientes(); fetchStats();
    } catch { toast.error('Erro na importação'); }
    finally { setImportLoading(false); }
  };

  const addTag = () => {
    const tag = tagInput.trim();
    if (tag && !form.tags.includes(tag)) { setForm(p => ({ ...p, tags: [...p.tags, tag] })); setTagInput(''); }
  };
  const removeTag = (tag) => setForm(p => ({ ...p, tags: p.tags.filter(t => t !== tag) }));

  const addContato = () => setForm(p => ({
    ...p,
    contatos: [
      ...p.contatos,
      {
        id: (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `ct_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        nome: '', email: '', cargo: '', telefone: '', whatsapp: '',
        principal: p.contatos.length === 0, // primeiro contato vira principal por padrão
      },
    ],
  }));
  const updateContato = (idx, field, value) => {
    const contatos = [...form.contatos];
    contatos[idx] = { ...contatos[idx], [field]: value };
    setForm(p => ({ ...p, contatos }));
  };
  const setContatoPrincipal = (idx) => {
    setForm(p => ({
      ...p,
      contatos: p.contatos.map((c, i) => ({ ...c, principal: i === idx })),
    }));
  };
  const removeContato = (idx) => setForm(p => {
    const filtered = p.contatos.filter((_, i) => i !== idx);
    // Se removeu o principal e ainda há contatos, promove o primeiro a principal
    if (filtered.length > 0 && !filtered.some(c => c.principal)) {
      filtered[0] = { ...filtered[0], principal: true };
    }
    return { ...p, contatos: filtered };
  });

  const addFrota = () => setForm(p => ({ ...p, frota: [...p.frota, { nome: '', tipo: '', ano: '', motor: '', observacao: '' }] }));
  const updateFrota = (idx, field, value) => {
    const frota = [...form.frota];
    frota[idx] = { ...frota[idx], [field]: value };
    setForm(p => ({ ...p, frota }));
  };
  const removeFrota = (idx) => setForm(p => ({ ...p, frota: p.frota.filter((_, i) => i !== idx) }));

  const estadosNosFiltros = useMemo(() => [...new Set(clientes.map(c => c.estado).filter(Boolean))].sort(), [clientes]);
  const getDocumento = (c) => c.cnpj || c.cpf || c.id_estrangeiro || '-';
  const getSegmentoLabel = (seg) => SEGMENTOS.find(s => s.value === seg)?.label || seg || '-';
  const getSegmentoBadgeColor = (seg) => {
    const map = { governo: 'bg-blue-100 text-blue-800', privado: 'bg-green-100 text-green-800', ong: 'bg-purple-100 text-purple-800', pessoa_fisica: 'bg-amber-100 text-amber-800' };
    return map[seg] || 'bg-gray-100 text-gray-600';
  };
  const formatCurrency = (v) => v ? `R$ ${parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '-';

  return (
    <div className="space-y-4" data-testid="crm-clientes-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-100 rounded-lg"><UserCircle2 className="h-6 w-6 text-indigo-600" /></div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-gray-900">Clientes</h1>
              <TitleWithHelp title="Clientes" description="Cadastro centralizado de clientes do CRM Náutico. Gerencie informações de contato, segmentação, frota e histórico comercial."
                connections={["Projetos — Clientes vinculados a projetos e embarcações", "Propostas — Base para propostas comerciais (em breve)", "Pipeline — Funil de oportunidades (em breve)"]}
                tips={["Use a Visão 360° para ver projetos e valor total do cliente", "Registre a frota existente para oportunidades de upsell", "Importe clientes via CSV para migração em massa"]} />
            </div>
            <p className="text-sm text-gray-500">Gestão de clientes e relacionamento comercial</p>
          </div>
        </div>
        <div className="flex gap-2">
          <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />
          <Button variant="outline" onClick={() => setShowImportDialog(true)} data-testid="btn-import-csv"><Upload className="mr-2 h-4 w-4" />Importar CSV</Button>
          <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={() => { setEditingCliente(null); setForm(emptyForm); setActiveTab('dados'); setShowDialog(true); }} data-testid="btn-novo-cliente"><Plus className="mr-2 h-4 w-4" />Novo Cliente</Button>
        </div>
      </div>

      {/* Stats */}
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="stats-cards">
          <Card><CardContent className="p-3 text-center"><div className="text-2xl font-bold text-indigo-600">{stats.total}</div><div className="text-xs text-gray-500">Total de Clientes</div></CardContent></Card>
          <Card><CardContent className="p-3 text-center"><div className="text-2xl font-bold text-green-600">{stats.ativos}</div><div className="text-xs text-gray-500">Ativos</div></CardContent></Card>
          <Card><CardContent className="p-3 text-center"><div className="text-2xl font-bold text-gray-400">{stats.inativos}</div><div className="text-xs text-gray-500">Inativos</div></CardContent></Card>
          <Card><CardContent className="p-3 text-center"><div className="text-2xl font-bold text-blue-600">{Object.keys(stats.por_segmento || {}).length}</div><div className="text-xs text-gray-500">Segmentos</div></CardContent></Card>
        </div>
      )}

      {/* Filtros */}
      <Card><CardContent className="p-3">
        <div className="flex flex-wrap gap-2 items-center">
          <div className="relative flex-1 min-w-[200px]">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
            <Input placeholder="Buscar por nome, CNPJ, email, contato, telefone..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-9" data-testid="search-clientes" />
          </div>
          <Select value={filterStatus} onValueChange={setFilterStatus}><SelectTrigger className="w-[130px]" data-testid="filter-status"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="todos">Todos Status</SelectItem><SelectItem value="ativo">Ativos</SelectItem><SelectItem value="inativo">Inativos</SelectItem></SelectContent></Select>
          <Select value={filterSegmento} onValueChange={setFilterSegmento}><SelectTrigger className="w-[160px]" data-testid="filter-segmento"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="todos">Todos Segmentos</SelectItem>{SEGMENTOS.filter(s => s.value).map(s => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent></Select>
          {estadosNosFiltros.length > 0 && <Select value={filterEstado} onValueChange={setFilterEstado}><SelectTrigger className="w-[100px]" data-testid="filter-estado"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="todos">UF</SelectItem>{estadosNosFiltros.map(uf => <SelectItem key={uf} value={uf}>{uf}</SelectItem>)}</SelectContent></Select>}
          <Badge variant="outline" className="text-xs">{filteredClientes.length} cliente{filteredClientes.length !== 1 ? 's' : ''}</Badge>
        </div>
      </CardContent></Card>

      {/* Tabela ou Cards */}
      {loading ? <Card><CardContent className="p-8 text-center text-gray-500">Carregando...</CardContent></Card>
      : filteredClientes.length === 0 ? <Card><CardContent className="p-8 text-center"><Users className="mx-auto h-10 w-10 text-gray-300 mb-3" /><p className="text-gray-500">Nenhum cliente encontrado</p></CardContent></Card>
      : viewMode === 'grid' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="clientes-grid-view">
          {filteredClientes.map(c => (
            <Card key={c.id} className="hover:shadow-md transition-shadow group" data-testid={`cliente-card-${c.id}`}>
              <CardContent className="p-4">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="bg-indigo-100 p-2 rounded-lg">
                      <UserCircle2 className="h-5 w-5 text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-900">{c.nome}</h3>
                      {c.razao_social && c.razao_social !== c.nome && <p className="text-xs text-gray-400 truncate max-w-[180px]">{c.razao_social}</p>}
                    </div>
                  </div>
                  <Badge className={c.status === 'ativo' ? 'bg-green-100 text-green-700 text-[10px]' : 'bg-gray-100 text-gray-500 text-[10px]'}>
                    {c.status === 'ativo' ? 'Ativo' : 'Inativo'}
                  </Badge>
                </div>
                <div className="space-y-1.5 text-sm text-gray-600 mb-3">
                  {c.email && <div className="flex items-center gap-2"><Mail className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" /><span className="truncate">{c.email}</span></div>}
                  {c.telefone && <div className="flex items-center gap-2"><Phone className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />{c.telefone}</div>}
                  {(c.cidade || c.estado) && <div className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />{c.cidade || ''}{c.cidade && c.estado ? '/' : ''}{c.estado || ''}</div>}
                </div>
                <div className="flex items-center justify-between pt-3 border-t">
                  <div className="flex gap-1 flex-wrap">
                    {c.segmento && <Badge className={`text-[10px] ${getSegmentoBadgeColor(c.segmento)}`}>{getSegmentoLabel(c.segmento)}</Badge>}
                    {c.tags?.slice(0, 2).map(t => <Badge key={t} variant="outline" className="text-[10px] px-1">{t}</Badge>)}
                  </div>
                  <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                    <Button variant="ghost" size="icon" className="h-7 w-7 text-indigo-500" onClick={() => fetch360(c.id)} title="360°"><Eye className="h-3.5 w-3.5" /></Button>
                    <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => handleEdit(c)} title="Editar"><Edit className="h-3.5 w-3.5" /></Button>
                    <Button variant="ghost" size="icon" className="h-7 w-7 text-red-500" onClick={() => setDeleteClienteId(c.id)} title="Excluir"><Trash2 className="h-3.5 w-3.5" /></Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
      <Card><CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="tabela-clientes">
              <thead><tr className="border-b bg-gray-50/70 text-left text-xs text-gray-500">
                <th className="px-3 py-2.5 font-medium">Cliente</th>
                <th className="px-3 py-2.5 font-medium">Documento</th>
                <th className="px-3 py-2.5 font-medium">Contato</th>
                <th className="px-3 py-2.5 font-medium">Cidade/UF</th>
                <th className="px-3 py-2.5 font-medium">Segmento</th>
                <th className="px-3 py-2.5 font-medium">Status</th>
                <th className="px-3 py-2.5 font-medium text-right">Ações</th>
              </tr></thead>
              <tbody>
                {filteredClientes.map(c => (
                  <tr key={c.id} className="border-b hover:bg-gray-50/50 transition-colors" data-testid={`cliente-row-${c.id}`}>
                    <td className="px-3 py-2.5">
                      <div className="font-medium text-gray-900 max-w-[200px] truncate">{c.nome}</div>
                      {c.razao_social && c.razao_social !== c.nome && <div className="text-xs text-gray-400 max-w-[200px] truncate">{c.razao_social}</div>}
                      {c.tags?.length > 0 && <div className="flex gap-1 mt-0.5 flex-wrap">{c.tags.slice(0, 2).map(t => <Badge key={t} variant="outline" className="text-[10px] px-1 py-0">{t}</Badge>)}{c.tags.length > 2 && <span className="text-[10px] text-gray-400">+{c.tags.length - 2}</span>}</div>}
                    </td>
                    <td className="px-3 py-2.5 text-xs text-gray-600 font-mono">{getDocumento(c)}</td>
                    <td className="px-3 py-2.5">
                      {c.email && <div className="flex items-center gap-1 text-xs text-gray-600"><Mail className="h-3 w-3 shrink-0" /><span className="truncate max-w-[150px]">{c.email}</span></div>}
                      {c.telefone && <div className="flex items-center gap-1 text-xs text-gray-600"><Phone className="h-3 w-3 shrink-0" />{c.telefone}</div>}
                    </td>
                    <td className="px-3 py-2.5 text-xs text-gray-600">{c.cidade || c.estado ? `${c.cidade || ''}${c.cidade && c.estado ? '/' : ''}${c.estado || ''}` : '-'}</td>
                    <td className="px-3 py-2.5">{c.segmento ? <Badge className={`text-[10px] ${getSegmentoBadgeColor(c.segmento)}`}>{getSegmentoLabel(c.segmento)}</Badge> : <span className="text-xs text-gray-300">-</span>}</td>
                    <td className="px-3 py-2.5"><Badge className={c.status === 'ativo' ? 'bg-green-100 text-green-700 text-[10px]' : 'bg-gray-100 text-gray-500 text-[10px]'}>{c.status === 'ativo' ? 'Ativo' : 'Inativo'}</Badge></td>
                    <td className="px-3 py-2.5 text-right">
                      <div className="flex justify-end gap-1">
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-indigo-500 hover:text-indigo-700" onClick={() => fetch360(c.id)} title="Visão 360°" data-testid={`btn-360-${c.id}`}><Eye className="h-3.5 w-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-purple-500 hover:text-purple-700" onClick={() => setHistoricoCliente(c)} title="Histórico" data-testid={`btn-historico-${c.id}`}><History className="h-3.5 w-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => handleEdit(c)} data-testid={`btn-edit-${c.id}`}><Edit className="h-3.5 w-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-red-500 hover:text-red-700" onClick={() => setDeleteClienteId(c.id)} data-testid={`btn-delete-${c.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      </CardContent></Card>
      )}

      {/* ========== DIALOG CADASTRO/EDIÇÃO ========== */}
      <Dialog open={showDialog} onOpenChange={(v) => { if (!v) { setShowDialog(false); setEditingCliente(null); } }}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="dialog-cliente">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><UserCircle2 className="h-5 w-5 text-indigo-600" />{editingCliente ? 'Editar Cliente' : 'Novo Cliente'}</DialogTitle></DialogHeader>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid grid-cols-5 w-full">
              <TabsTrigger value="dados">Dados</TabsTrigger>
              <TabsTrigger value="endereco">Endereço</TabsTrigger>
              <TabsTrigger value="contatos">Contatos{form.contatos.length > 0 ? ` (${form.contatos.length})` : ''}</TabsTrigger>
              <TabsTrigger value="frota">Frota{form.frota.length > 0 ? ` (${form.frota.length})` : ''}</TabsTrigger>
              <TabsTrigger value="crm">CRM</TabsTrigger>
            </TabsList>

            {/* Aba Dados */}
            <TabsContent value="dados" className="space-y-3 mt-3">
              <div className="grid grid-cols-3 gap-3">
                <div className="col-span-2"><Label className="text-xs">Nome *</Label><Input value={form.nome} onChange={e => setForm(p => ({...p, nome: e.target.value}))} placeholder="Nome do cliente" data-testid="input-nome" /></div>
                <div><Label className="text-xs">Tipo Pessoa</Label><Select value={form.tipo_pessoa} onValueChange={v => setForm(p => ({...p, tipo_pessoa: v}))}><SelectTrigger data-testid="select-tipo-pessoa"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="juridica">Jurídica</SelectItem><SelectItem value="fisica">Física</SelectItem><SelectItem value="estrangeiro">Estrangeiro</SelectItem></SelectContent></Select></div>
              </div>
              <div><Label className="text-xs">Razão Social</Label><Input value={form.razao_social} onChange={e => setForm(p => ({...p, razao_social: e.target.value}))} data-testid="input-razao" /></div>
              <div className="grid grid-cols-3 gap-3">
                {form.tipo_pessoa === 'juridica' && <><div><Label className="text-xs">CNPJ *</Label><Input value={form.cnpj} onChange={e => setForm(p => ({...p, cnpj: e.target.value}))} placeholder="00.000.000/0000-00" data-testid="input-cnpj" /></div><div><Label className="text-xs">Inscrição Estadual</Label><Input value={form.inscricao_estadual} onChange={e => setForm(p => ({...p, inscricao_estadual: e.target.value}))} /></div></>}
                {form.tipo_pessoa === 'fisica' && <div><Label className="text-xs">CPF *</Label><Input value={form.cpf} onChange={e => setForm(p => ({...p, cpf: e.target.value}))} placeholder="000.000.000-00" data-testid="input-cpf" /></div>}
                {form.tipo_pessoa === 'estrangeiro' && <div><Label className="text-xs">ID Estrangeiro *</Label><Input value={form.id_estrangeiro} onChange={e => setForm(p => ({...p, id_estrangeiro: e.target.value}))} /></div>}
                <div><Label className="text-xs">Código</Label><Input value={form.codigo} onChange={e => setForm(p => ({...p, codigo: e.target.value}))} data-testid="input-codigo" /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label className="text-xs">E-mail principal *</Label><Input value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))} data-testid="input-email" placeholder="Pode ser o de um contato principal" /></div>
                <div><Label className="text-xs">Telefone principal *</Label><Input value={form.telefone} onChange={e => setForm(p => ({...p, telefone: e.target.value}))} data-testid="input-telefone" placeholder="Pode ser o de um contato principal" /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label className="text-xs">Status</Label><Select value={form.status} onValueChange={v => setForm(p => ({...p, status: v}))}><SelectTrigger data-testid="select-status"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="ativo">Ativo</SelectItem><SelectItem value="inativo">Inativo</SelectItem></SelectContent></Select></div>
                <div><Label className="text-xs">Data Fundação / Aniversário</Label><Input value={form.data_fundacao} onChange={e => setForm(p => ({...p, data_fundacao: e.target.value}))} /></div>
              </div>
              <div><Label className="text-xs">Observações</Label><Textarea value={form.observacoes} onChange={e => setForm(p => ({...p, observacoes: e.target.value}))} rows={2} data-testid="input-obs" /></div>
            </TabsContent>

            {/* Aba Endereço */}
            <TabsContent value="endereco" className="space-y-3 mt-3">
              <div className="grid grid-cols-3 gap-3">
                <div><Label className="text-xs">CEP</Label><Input value={form.cep} onChange={e => setForm(p => ({...p, cep: e.target.value}))} data-testid="input-cep" /></div>
                <div><Label className="text-xs">Estado</Label><Select value={form.estado || 'none'} onValueChange={v => setForm(p => ({...p, estado: v === 'none' ? '' : v}))}><SelectTrigger data-testid="select-estado"><SelectValue placeholder="UF" /></SelectTrigger><SelectContent><SelectItem value="none">Selecionar</SelectItem>{ESTADOS_BR.map(uf => <SelectItem key={uf} value={uf}>{uf}</SelectItem>)}</SelectContent></Select></div>
                <div><Label className="text-xs">Cidade</Label><Input value={form.cidade} onChange={e => setForm(p => ({...p, cidade: e.target.value}))} data-testid="input-cidade" /></div>
              </div>
              <div className="grid grid-cols-4 gap-3">
                <div className="col-span-2"><Label className="text-xs">Endereço</Label><Input value={form.endereco} onChange={e => setForm(p => ({...p, endereco: e.target.value}))} data-testid="input-endereco" /></div>
                <div><Label className="text-xs">Número</Label><Input value={form.numero} onChange={e => setForm(p => ({...p, numero: e.target.value}))} /></div>
                <div><Label className="text-xs">Bairro</Label><Input value={form.bairro} onChange={e => setForm(p => ({...p, bairro: e.target.value}))} /></div>
              </div>
              <div><Label className="text-xs">Complemento</Label><Input value={form.complemento} onChange={e => setForm(p => ({...p, complemento: e.target.value}))} /></div>
            </TabsContent>

            {/* Aba Contatos (com WhatsApp) */}
            <TabsContent value="contatos" className="space-y-3 mt-3">
              <div className="flex justify-between items-center">
                <Label className="text-sm font-medium">Contatos da empresa</Label>
                <Button variant="outline" size="sm" onClick={addContato} data-testid="btn-add-contato"><UserPlus className="h-3.5 w-3.5 mr-1" />Adicionar</Button>
              </div>
              {form.contatos.length === 0 && <div className="text-center py-6 text-gray-400 text-sm">Nenhum contato cadastrado</div>}
              {form.contatos.map((ct, idx) => (
                <Card
                  key={ct.id || `contato-${idx}`}
                  className={ct.principal ? 'border-blue-400 bg-blue-50/40' : ''}
                >
                  <CardContent className="p-3 space-y-2">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-medium text-gray-500">Contato #{idx + 1}</span>
                      {ct.principal && (
                        <span className="text-[10px] uppercase font-semibold text-blue-700 bg-blue-100 rounded px-1.5 py-0.5">
                          Principal
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <label className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer select-none">
                        <input
                          type="radio"
                          name={`contato-principal-${editingCliente?.id || 'novo'}`}
                          checked={!!ct.principal}
                          onChange={() => setContatoPrincipal(idx)}
                          className="h-3 w-3 accent-blue-600 cursor-pointer"
                          data-testid={`contato-principal-${idx}`}
                        />
                        Marcar como principal
                      </label>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="h-6 w-6 text-red-400"
                        onClick={() => removeContato(idx)}
                        data-testid={`contato-remove-${idx}`}
                      >
                        <X className="h-3 w-3" />
                      </Button>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div><Label className="text-xs">Nome</Label><Input value={ct.nome} onChange={e => updateContato(idx, 'nome', e.target.value)} data-testid={`contato-nome-${idx}`} /></div>
                    <div><Label className="text-xs">Cargo</Label><Input value={ct.cargo} onChange={e => updateContato(idx, 'cargo', e.target.value)} /></div>
                    <div><Label className="text-xs">E-mail</Label><Input value={ct.email} onChange={e => updateContato(idx, 'email', e.target.value)} /></div>
                    <div><Label className="text-xs">Telefone</Label><Input value={ct.telefone} onChange={e => updateContato(idx, 'telefone', e.target.value)} /></div>
                    <div><Label className="text-xs flex items-center gap-1"><WhatsAppIcon className="h-3 w-3 text-green-600" />WhatsApp</Label><Input value={ct.whatsapp || ''} onChange={e => updateContato(idx, 'whatsapp', e.target.value)} placeholder="(00) 00000-0000" /></div>
                  </div>
                </CardContent></Card>
              ))}
            </TabsContent>

            {/* Aba Frota */}
            <TabsContent value="frota" className="space-y-3 mt-3">
              <div className="flex justify-between items-center">
                <div>
                  <Label className="text-sm font-medium">Frota do cliente</Label>
                  <p className="text-xs text-gray-400">Registre as embarcações que o cliente já possui</p>
                </div>
                <Button variant="outline" size="sm" onClick={addFrota} data-testid="btn-add-frota"><Ship className="h-3.5 w-3.5 mr-1" />Adicionar Embarcação</Button>
              </div>
              {form.frota.length === 0 && <div className="text-center py-6 text-gray-400 text-sm"><Anchor className="mx-auto h-8 w-8 text-gray-300 mb-2" />Nenhuma embarcação registrada na frota</div>}
              {form.frota.map((emb, idx) => (
                <Card key={emb.nome || emb.modelo || idx}><CardContent className="p-3 space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-medium text-gray-500 flex items-center gap-1"><Ship className="h-3 w-3" />Embarcação #{idx + 1}</span>
                    <Button variant="ghost" size="icon" className="h-6 w-6 text-red-400" onClick={() => removeFrota(idx)}><X className="h-3 w-3" /></Button>
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    <div><Label className="text-xs">Nome / Identificação</Label><Input value={emb.nome} onChange={e => updateFrota(idx, 'nome', e.target.value)} placeholder="Ex: ALPHA-01" /></div>
                    <div><Label className="text-xs">Tipo</Label><Input value={emb.tipo} onChange={e => updateFrota(idx, 'tipo', e.target.value)} placeholder="Ex: Lancha, Barco" /></div>
                    <div><Label className="text-xs">Ano</Label><Input value={emb.ano} onChange={e => updateFrota(idx, 'ano', e.target.value)} placeholder="2024" /></div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div><Label className="text-xs">Motor</Label><Input value={emb.motor} onChange={e => updateFrota(idx, 'motor', e.target.value)} placeholder="Ex: Mercury 250HP" /></div>
                    <div><Label className="text-xs">Observação</Label><Input value={emb.observacao} onChange={e => updateFrota(idx, 'observacao', e.target.value)} /></div>
                  </div>
                </CardContent></Card>
              ))}
            </TabsContent>

            {/* Aba CRM */}
            <TabsContent value="crm" className="space-y-3 mt-3">
              <div className="grid grid-cols-2 gap-3">
                <div><Label className="text-xs">Segmento</Label><Select value={form.segmento || 'none'} onValueChange={v => setForm(p => ({...p, segmento: v === 'none' ? '' : v}))}><SelectTrigger data-testid="select-segmento"><SelectValue /></SelectTrigger><SelectContent>{SEGMENTOS.map(s => <SelectItem key={s.value || 'none'} value={s.value || 'none'}>{s.label}</SelectItem>)}</SelectContent></Select></div>
                <div><Label className="text-xs">Origem</Label><Select value={form.origem || 'none'} onValueChange={v => setForm(p => ({...p, origem: v === 'none' ? '' : v}))}><SelectTrigger data-testid="select-origem"><SelectValue /></SelectTrigger><SelectContent>{ORIGENS.map(o => <SelectItem key={o.value || 'none'} value={o.value || 'none'}>{o.label}</SelectItem>)}</SelectContent></Select></div>
              </div>
              <div>
                <Label className="text-xs">Tags</Label>
                <div className="flex gap-2 items-center">
                  <Input value={tagInput} onChange={e => setTagInput(e.target.value)} placeholder="Adicionar tag..." className="flex-1" onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addTag(); } }} data-testid="input-tag" />
                  <Button variant="outline" size="sm" onClick={addTag}><Tag className="h-3.5 w-3.5" /></Button>
                </div>
                {form.tags.length > 0 && <div className="flex gap-1 flex-wrap mt-2">{form.tags.map(t => <Badge key={t} variant="secondary" className="text-xs gap-1">{t}<button onClick={() => removeTag(t)} className="hover:text-red-500"><X className="h-2.5 w-2.5" /></button></Badge>)}</div>}
              </div>
            </TabsContent>
          </Tabs>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => { setShowDialog(false); setEditingCliente(null); }}>Cancelar</Button>
            <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={handleSubmit} disabled={submitLoading} data-testid="btn-salvar-cliente">{submitLoading ? 'Salvando...' : editingCliente ? 'Atualizar' : 'Cadastrar'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* ========== VISÃO 360° ========== */}
      <Dialog open={show360} onOpenChange={(v) => { if (!v) setShow360(false); }}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto p-0" data-testid="dialog-360">
          {loading360 ? <div className="p-12 text-center text-gray-500">Carregando visão 360°...</div>
          : cliente360 && (
            <>
              {/* Header 360 */}
              <div className="bg-gradient-to-r from-indigo-600 to-indigo-800 text-white p-5">
                <div className="flex justify-between items-start">
                  <div>
                    <h2 className="text-xl font-bold">{cliente360.cliente.nome}</h2>
                    {cliente360.cliente.razao_social && cliente360.cliente.razao_social !== cliente360.cliente.nome && <p className="text-indigo-200 text-sm">{cliente360.cliente.razao_social}</p>}
                    <div className="flex items-center gap-3 mt-2">
                      {cliente360.cliente.segmento && <Badge className="bg-white/20 text-white text-xs">{getSegmentoLabel(cliente360.cliente.segmento)}</Badge>}
                      <Badge className={`text-xs ${cliente360.cliente.status === 'ativo' ? 'bg-green-400/30 text-green-100' : 'bg-gray-400/30 text-gray-200'}`}>{cliente360.cliente.status === 'ativo' ? 'Ativo' : 'Inativo'}</Badge>
                      {cliente360.cliente.tags?.map(t => <Badge key={t} className="bg-white/10 text-white text-[10px]">{t}</Badge>)}
                    </div>
                  </div>
                  <div className="text-right text-sm">
                    {cliente360.cliente.email && <div className="flex items-center gap-1 justify-end"><Mail className="h-3.5 w-3.5" />{cliente360.cliente.email}</div>}
                    {cliente360.cliente.telefone && <div className="flex items-center gap-1 justify-end"><Phone className="h-3.5 w-3.5" />{cliente360.cliente.telefone}</div>}
                    {(cliente360.cliente.cidade || cliente360.cliente.estado) && <div className="flex items-center gap-1 justify-end"><MapPin className="h-3.5 w-3.5" />{cliente360.cliente.cidade}{cliente360.cliente.cidade && cliente360.cliente.estado ? '/' : ''}{cliente360.cliente.estado}</div>}
                  </div>
                </div>

                {/* KPIs */}
                <div className="grid grid-cols-4 gap-3 mt-4">
                  <div className="bg-white/10 rounded-lg p-2.5 text-center"><div className="text-2xl font-bold">{cliente360.resumo.total_projetos}</div><div className="text-xs text-indigo-200">Projetos</div></div>
                  <div className="bg-white/10 rounded-lg p-2.5 text-center"><div className="text-2xl font-bold">{cliente360.resumo.projetos_ativos}</div><div className="text-xs text-indigo-200">Ativos</div></div>
                  <div className="bg-white/10 rounded-lg p-2.5 text-center"><div className="text-2xl font-bold">{cliente360.resumo.total_embarcacoes}</div><div className="text-xs text-indigo-200">Embarcações</div></div>
                  <div className="bg-white/10 rounded-lg p-2.5 text-center"><div className="text-lg font-bold">{formatCurrency(cliente360.resumo.total_orcamento)}</div><div className="text-xs text-indigo-200">Valor Total</div></div>
                </div>
              </div>

              <div className="p-5 space-y-4">
                {/* Dados Cadastrais */}
                <div>
                  <h3 className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-1.5"><Building2 className="h-4 w-4" />Dados Cadastrais</h3>
                  <div className="grid grid-cols-3 gap-2 text-xs">
                    {cliente360.cliente.cnpj && <div><span className="text-gray-400">CNPJ:</span> <span className="font-mono">{cliente360.cliente.cnpj}</span></div>}
                    {cliente360.cliente.cpf && <div><span className="text-gray-400">CPF:</span> <span className="font-mono">{cliente360.cliente.cpf}</span></div>}
                    {cliente360.cliente.inscricao_estadual && <div><span className="text-gray-400">IE:</span> {cliente360.cliente.inscricao_estadual}</div>}
                    {cliente360.cliente.codigo && <div><span className="text-gray-400">Código:</span> {cliente360.cliente.codigo}</div>}
                    {cliente360.cliente.data_fundacao && <div><span className="text-gray-400">Fundação:</span> {cliente360.cliente.data_fundacao}</div>}
                    {cliente360.cliente.endereco && <div className="col-span-2"><span className="text-gray-400">Endereço:</span> {cliente360.cliente.endereco}{cliente360.cliente.numero ? `, ${cliente360.cliente.numero}` : ''}{cliente360.cliente.bairro ? ` - ${cliente360.cliente.bairro}` : ''}{cliente360.cliente.cep ? ` (${cliente360.cliente.cep})` : ''}</div>}
                  </div>
                </div>

                {/* Contatos */}
                {cliente360.cliente.contatos?.length > 0 && (
                  <div>
                    <h3 className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-1.5"><Users className="h-4 w-4" />Contatos ({cliente360.cliente.contatos.length})</h3>
                    <div className="grid grid-cols-2 gap-2">
                      {cliente360.cliente.contatos.map((ct, idx) => (
                        <div key={idx} className="border rounded-lg p-2 text-xs">
                          <div className="font-medium">{ct.nome || '-'}{ct.cargo && <span className="text-gray-400 ml-1">({ct.cargo})</span>}</div>
                          <div className="text-gray-500 space-y-0.5 mt-1">
                            {ct.email && <div className="flex items-center gap-1"><Mail className="h-3 w-3" />{ct.email}</div>}
                            {ct.telefone && <div className="flex items-center gap-1"><Phone className="h-3 w-3" />{ct.telefone}</div>}
                            {ct.whatsapp && <div className="flex items-center gap-1"><WhatsAppIcon className="h-3 w-3 text-green-600" />{ct.whatsapp}</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Frota */}
                {cliente360.cliente.frota?.length > 0 && (
                  <div>
                    <h3 className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-1.5"><Anchor className="h-4 w-4" />Frota ({cliente360.cliente.frota.length} embarcações)</h3>
                    <div className="grid grid-cols-2 gap-2">
                      {cliente360.cliente.frota.map((emb, idx) => (
                        <div key={idx} className="border rounded-lg p-2 text-xs flex gap-2">
                          <Ship className="h-5 w-5 text-indigo-400 shrink-0 mt-0.5" />
                          <div>
                            <div className="font-medium">{emb.nome || `Embarcação ${idx + 1}`}</div>
                            <div className="text-gray-500">{[emb.tipo, emb.ano, emb.motor].filter(Boolean).join(' · ')}</div>
                            {emb.observacao && <div className="text-gray-400 mt-0.5">{emb.observacao}</div>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Histórico de Projetos */}
                <div>
                  <h3 className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-1.5"><FolderKanban className="h-4 w-4" />Histórico de Projetos ({cliente360.resumo.total_projetos})</h3>
                  {cliente360.projetos.length === 0 ? (
                    <div className="text-center py-4 text-gray-400 text-sm border rounded-lg">Nenhum projeto vinculado a este cliente</div>
                  ) : (
                    <div className="space-y-2">
                      {cliente360.projetos.map(p => {
                        const st = STATUS_PROJETO[p.status] || { label: p.status, color: 'bg-gray-100 text-gray-700' };
                        return (
                          <div key={p.id} className="border rounded-lg p-3 hover:bg-gray-50 transition-colors" data-testid={`projeto-360-${p.id}`}>
                            <div className="flex justify-between items-start">
                              <div>
                                <div className="font-medium text-sm">{p.name}</div>
                                <div className="text-xs text-gray-500 flex items-center gap-2 mt-0.5">
                                  {p.vessel_type && <span className="flex items-center gap-0.5"><Ship className="h-3 w-3" />{p.vessel_type}</span>}
                                  <span className="flex items-center gap-0.5"><Calendar className="h-3 w-3" />{p.start_date ? new Date(p.start_date).toLocaleDateString('pt-BR') : '-'}</span>
                                  {p.embarcacoes && <span>{p.embarcacoes.length} emb.</span>}
                                </div>
                              </div>
                              <div className="flex items-center gap-2">
                                {(p.valor_venda || p.budget) > 0 && <span className="text-xs font-medium text-gray-600">{formatCurrency(p.valor_venda ?? p.budget)}</span>}
                                <Badge className={`text-[10px] ${st.color}`}>{st.label}</Badge>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Observações */}
                {cliente360.cliente.observacoes && (
                  <div>
                    <h3 className="text-sm font-bold text-gray-700 mb-1">Observações</h3>
                    <p className="text-xs text-gray-600 bg-gray-50 rounded-lg p-2">{cliente360.cliente.observacoes}</p>
                  </div>
                )}
              </div>

              <div className="p-4 border-t flex justify-end gap-2">
                <Button variant="outline" onClick={() => { setShow360(false); handleEdit(cliente360.cliente); }}>
                  <Edit className="mr-2 h-4 w-4" />Editar Cliente
                </Button>
                <Button variant="outline" onClick={() => setShow360(false)}>Fechar</Button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Importação CSV */}
      <Dialog open={showImportDialog} onOpenChange={setShowImportDialog}>
        <DialogContent className="max-w-md" data-testid="dialog-import">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Upload className="h-5 w-5 text-indigo-600" />Importar Clientes (CSV)</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <p className="text-sm text-gray-600">Selecione um arquivo CSV com separador <code className="bg-gray-100 px-1 rounded">;</code></p>
            <div className="border-2 border-dashed border-gray-200 rounded-lg p-4 text-center">
              <input type="file" accept=".csv" onChange={handleImport} disabled={importLoading} className="w-full text-sm" data-testid="input-csv-file" />
            </div>
            {importLoading && <div className="text-center text-sm text-indigo-600">Importando...</div>}
            {importResult && (
              <div className="bg-gray-50 rounded-lg p-3 text-sm space-y-1" data-testid="import-result">
                <div className="flex justify-between"><span>Importados:</span><span className="font-bold text-green-600">{importResult.importados}</span></div>
                <div className="flex justify-between"><span>Duplicados:</span><span className="font-bold text-amber-600">{importResult.duplicados}</span></div>
                <div className="flex justify-between"><span>Erros:</span><span className="font-bold text-red-600">{importResult.erros}</span></div>
                <div className="flex justify-between border-t pt-1"><span>Total:</span><span className="font-bold">{importResult.total_processado}</span></div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Confirmação de Exclusão */}
      <AlertDialog open={!!deleteClienteId} onOpenChange={() => setDeleteClienteId(null)}>
        <AlertDialogContent><AlertDialogHeader><AlertDialogTitle>Excluir cliente?</AlertDialogTitle><AlertDialogDescription>Esta ação não pode ser desfeita.</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel>Cancelar</AlertDialogCancel><AlertDialogAction className="bg-red-600 hover:bg-red-700" onClick={handleDelete} data-testid="btn-confirm-delete">Excluir</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Histórico Centralizado */}
      <HistoricoClienteModal
        clienteId={historicoCliente?.id}
        clienteNome={historicoCliente?.nome}
        open={!!historicoCliente}
        onClose={() => setHistoricoCliente(null)}
      />
    </div>
  );
};

export default CrmClientes;
